import React from 'react';

import { useTranslations } from 'next-intl';

import PredictionPriceCount from '@/app/[locale]/(main)/live-predictions/[symbol]/_components/PredictionPrice/PredictionPriceCount';
import ActivityMyTokens from '@/assets/icons/activity-mytokens.svg';
import USDCIcon from '@/assets/icons/usdc.svg';

interface I_PoolStatsProps {
  totalPoolVolume: string;
  totalPoolTokens: string;
}

export function PoolStats({
  totalPoolVolume,
  totalPoolTokens
}: I_PoolStatsProps) {
  const t = useTranslations('pools');

  return (
    <div className="grid gap-4 grid-cols-2">
      <PredictionPriceCount
        label={t('poolVolume')}
        value={totalPoolVolume}
        icon={<USDCIcon />}
        className="bg-[image:var(--pool-prize-gradient)] banner-gradient-animation"
      />
      <PredictionPriceCount
        label={t('poolTokens')}
        value={totalPoolTokens}
        icon={<ActivityMyTokens />}
        className="bg-[image:var(--pool-card-btc-gradient)] banner-gradient-animation"
      />
    </div>
  );
}
